// libs
import styled from "@emotion/styled";

// constants
import { TEXT_PRIMARY } from "shared/styles/base";

// mixins
import { resetButton } from "shared/styles/mixin";

export const Container = styled.div``;

export const Button = styled.button`
    ${resetButton}

    position: relative;
    display: block;
    width: 100%;
    outline: none;
    text-align: left;
`;

export const Expander = styled.i`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 11px;
    height: 11px;

    &:before,
    &:after {
        content: "";
        position: absolute;
        background-color: ${TEXT_PRIMARY};
        transition: transform 0.25s ease-out;
    }

    &:before {
        top: -1px;
        left: calc(50% - 1px);
        width: 1px;
        height: 100%;
    }

    /* horizontal line */
    &:after {
        left: 0;
        top: calc(50% - 1px);
        width: 100%;
        height: 1px;
    }

    &.expanded {
        &:before {
            transform: rotate(90deg);
        }
        &:after {
            transform: rotate(180deg);
        }
    }
`;

export const Content = styled.div`
    overflow: hidden;
    transition: height 0.25s linear;
`;
